import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import UserPage from "./pages/UserPage";
import Login from "./components/auth/Login";
import PrivateRoute from "./components/routes/PrivateRoute";
import AdminPrivateRoute from "./components/routes/AdminPrivateRoute.js";
import DjPage from "./pages/DjPage";
import CancelPage from "./pages/CancelPage";
import NotFoundPage from "./pages/NotFoundPage";
import { ToastContainer } from "react-toastify";
import RegistrationPage from "./pages/RegistrationPage";
import AdminPage from "./pages/AdminPage";
import AdminLogin from "./components/auth/AdminLogin";
import RequestsPage from "./pages/admin/RequestsPage";
import RequestDetailsPage from "./pages/admin/RequestDetailsPage";
import DjsPage from "./pages/admin/DjsPage";
import PlacesPage from "./pages/admin/PlacesPage";
import TransactionsPage from "./pages/admin/TransactionsPage";
import DjDetailsPage from "./pages/admin/DjDetailsPage";
import InviteTokenPage from "./pages/admin/InviteTokenPage";
import Dashboard from "./pages/admin/Dashboard";
import DjForgotPassword from "./components/auth/DjForgotPassword";
import DjResetPassword from "./components/auth/DjResetPassword";
import InvitationsPage from "pages/admin/InvitationsPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UserPage />} />
        <Route path="/select" element={<UserPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/forgot-password" element={<DjForgotPassword />} />
        <Route path="/auth/reset-password/" element={<DjResetPassword />} />
        <Route path="/admin/auth/login" element={<AdminLogin />} />
        <Route
          path="/dj-panel"
          element={
            <PrivateRoute>
              <DjPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-panel"
          element={
            <AdminPrivateRoute>
              <AdminPage />
            </AdminPrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="requests" element={<RequestsPage />} />
          <Route path="requests/:id" element={<RequestDetailsPage />} />
          <Route path="djs" element={<DjsPage />} />
          <Route path="djs/:id" element={<DjDetailsPage />} />
          <Route path="places" element={<PlacesPage />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="invite-token" element={<InviteTokenPage />} />
          <Route path="invitations" element={<InvitationsPage />} />
        </Route>
        <Route
          path="/auth/registration/:token"
          element={<RegistrationPage />}
        />
        <Route path="/payment/cancel" element={<CancelPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        theme="dark"
        className="text-white"
      />
    </Router>
  );
}

export default App;
